const Footer: React.FC = () => {
  return (
    <footer className="mt-16 pb-8 text-center text-sm text-gray-400">
      © {new Date().getFullYear()} Built by Ashan M Silva. All Rights Reserved.
    </footer>
  );
};

export default Footer;
